import * as React from "react"

export default function SearchIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.025 13.848l3.57 3.568-1.18 1.179-3.568-3.57a7.467 7.467 0 01-4.681 1.642c-4.14 0-7.5-3.36-7.5-7.5 0-4.14 3.36-7.5 7.5-7.5 4.14 0 7.5 3.36 7.5 7.5a7.467 7.467 0 01-1.64 4.68zm-1.671-.619a5.814 5.814 0 001.645-4.062 5.832 5.832 0 00-5.833-5.834 5.831 5.831 0 00-5.833 5.834A5.832 5.832 0 009.166 15a5.815 5.815 0 004.063-1.646l.125-.125z"
        fill={props.fill}
      />
    </svg>
  )
}
